<!--
 * @Description:
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-02-27 13:25:48
 * @LastEditors: situgen@szkingdom.com
-->
<!--
Author: TangChen
Date: 2018-09-05
Desc: 登录后页面组件，由router.js 配置引入
-->
<template>
    <div class="view-frame view">
        <header-com :tit="titText"></header-com>
        <el-container class="home-box">
            <el-main>
                <router-view :key="$route.name" />
                <log />
            </el-main>
        </el-container>
        <!--<footer-com style="visibility: hidden;" />-->
        <zx-footer style="position: absolute; bottom: 0"></zx-footer>
        <!-- <footer-com /> -->
    </div>
</template>
<script>
import headerCom from "@/components/layout/headerDc.vue";

import zxFooter from "@/components/layout/zxFooter.vue";
import log from "@/components/misc/log.vue";
export default {
    components: {
        headerCom,
        log,
        zxFooter
    },
    data() {
        return {
            url: "",
            titText: ""
        };
    },
    mounted() {
        if (this.$route.meta) {
            this.titText = this.$route.meta.tit || "";
        }
    },
    methods: {}
};
</script>
<style lang="scss">
.view-frame {
    min-height: 500px;
    background: #fff;
    .home-box {
        width: 1200px;
        // margin: 20px auto 390px;
        margin: 20px auto 145px;
        .menu-nav {
            overflow: hidden;
            margin-right: 14px;
        }
        .el-main {
            min-height: 400px;
            padding: 0;
            .bizcomp:first-child {
                margin-top: 0;
            }
        }
    }
}
</style>
